export { ZipcodeModule as default } from "./zipcode-module";
export type { ZipcodeModuleProps } from "./zipcode-module.props";
